<nav #menu class="menu">
  <div class="logo" [class.should-display]="menu.shouldShowLogo$ | async" (click)="goHome()">
    <div class="logo--speechbubble">
      <svg viewBox="0 0 62 37" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M36.7 0H24.67c0 5.1 1.04 9.93 2.92 14.34h-7.51A24.64 24.64 0 0 1 0 24.7v12.01c12.84 0 24.14-6.6 30.7-16.6a36.67 36.67 0 0 0 30.68 16.6v-12A24.72 24.72 0 0 1 36.69 0Z"
          fill="#002E33"
        />
      </svg>
    </div>
  </div>

  <!-- Scoped file input -->
  <input #fileInput type="file" style="display: none" accept="application/pdf, image/jpg, image/png, image/jpeg" multiple (change)="onFileAdded($event)" />

  <!-- Menu itself / unordered list -->
  <ul #list>
    <!-- Quick actions -->
    <div class="quick-actions">
      <a (click)="navigateTo('invoice')" class="item quick-action-make-invoice">
        <tlw-icon icon="plus" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.CREATE_INVOICE' | translate }}
      </a>
      <a (click)="navigateTo('quote')" class="item quick-action-make-quote">
        <tlw-icon icon="write" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.CREATE_QUOTE' | translate }}
      </a>
      <a (click)="navigateTo('upload')" class="item quick-action-make-annotation">
        <tlw-icon icon="upload" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.QUICK_BOOK' | translate }}
      </a>
    </div>

    <!-- Top starts here -->
    <div class="top menu-scope">
      <!-- Home -->
      <menu-item path="" closeOthers="all" section="home">
        <tlw-icon icon="house" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.HOME' | translate }}
      </menu-item>

      <!-- Bank -->
      <menu-group name="banking" (click)="toggleMenuState('banking')">
        <tlw-icon icon="card" library="heroicons" variant="mini"></tlw-icon>
        <span>{{ 'MAIN.BANKING' | translate }}<span class="new-content" *ngIf="shouldSeeBankingNewContent"></span></span>
      </menu-group>
      <sub-menu name="banking" [paths]="['transactions', 'banking', 'transferMoney', 'leningen', 'settings/banking/cardSettings']">
        <!-- Transactions -->
        <menu-item path="transactions" closeOthers="banking" [exact]="false">{{ 'MAIN.BANK_TRANSACTIONS' | translate }}</menu-item>
        <!-- Open bank account -->
        <menu-item *ngIf="!hasSwanAccount" closeOthers="banking" path="banking" [exact]="false">{{ 'MAIN.BANKING_ONBOARD' | translate }}</menu-item>
        <!-- Transfer -->
        <a tabindex="0" *ngIf="canSeeTransferButton" (click)="checkBankAccountBalance()" [class.active]="isActiveBypass('transferMoney')">
          {{ 'BANKING.TRANSFER.TRANSFER_MONEY' | translate }}
        </a>
        <!-- Cards -->
        <a tabindex="0" *ngIf="canSeeCardsButton" (click)="navigateToCards()" [class.active]="isActiveBypass('settings/banking/cardSettings')">
          {{ 'SETTINGS.CARD' | translate }}
          <span class="new-content" *ngIf="shouldSeeBankingCardsNewContent"></span>
        </a>
        <!-- Onboard to Tax Buckets -->
        <a tabindex="0" *ngIf="canOnboardToTaxBuckets" (click)="modals.taxBucketsOnboardingModal.open()">
          {{ 'MAIN.TAX_SAVING' | translate }}
        </a>
        <!-- Loans -->
        <menu-item path="leningen" closeOthers="banking" [exact]="false">{{ 'MAIN.LOANS' | translate }}</menu-item>
      </sub-menu>

      <!-- Expenses -->
      <menu-item path="expenses" closeOthers="all" section="expenses">
        <tlw-icon icon="inbox" library="heroicons" variant="mini"></tlw-icon>
        {{ 'EXPENSES.EXPENSES' | translate }}
      </menu-item>

      <!-- Verkoop -->
      <menu-group name="sales" (click)="toggleMenuState('sales')">
        <tlw-icon icon="folder" library="heroicons" variant="mini"></tlw-icon>
        <span> {{ 'MAIN.SALES' | translate }} </span>
      </menu-group>
      <sub-menu name="sales" [paths]="['invoices', 'quotes', 'contacts', 'sending']">
        <!-- Facturen -->
        <menu-item path="invoices" closeOthers="sales" [paths]="['invoices', 'sending/invoice']">{{ 'MAIN.GENERAL_INVOICES' | translate }} </menu-item>
        <!-- Offertes -->
        <a tabindex="0" (click)="navigateToQuoteOverview()" [class.active]="isActiveBypass(['quotes', 'sending/quote'])">
          {{ 'MAIN.QUOTES' | translate }}
        </a>
        <!-- Adresboek -->
        <menu-item path="contacts" closeOthers="sales">{{ 'MAIN.CONTACTS' | translate }}</menu-item>
      </sub-menu>

      <!-- Belasting -->
      <menu-group name="tax" (click)="toggleMenuState('tax')">
        <tlw-icon icon="calculator" library="heroicons" variant="mini"></tlw-icon>
        <span> {{ 'MAIN.TAXES' | translate }} </span>
      </menu-group>
      <sub-menu name="tax" [paths]="['vat', 'vat/incomeTax']">
        <!-- Btw-aangifte -->
        <menu-item *ngIf="showVatMenuItem" closeOthers="tax" [exact]="true" path="vat">{{ 'MAIN.VAT_DECLARATION' | translate }} </menu-item>

        <!-- Inkomstenbelasting / Vennootschapsbelasting -->
        <ng-container *ngIf="planName$ | async as plan">
          <a
            *ngIf="isBV !== null"
            routerLinkActive="active"
            [routerLink]="plan === plans.Compleet && !isBV ? ('/vat/incomeTax' | translateRoute) : undefined"
            (click)="plan === plans.Compleet && !isBV ? navigateToIncomeTax() : modals.openBookkeeping()"
          >
            {{ (isBV ? 'MAIN.BV_TAX' : 'MAIN.FINANCIAL_ADVICE') | translate }}
          </a>
        </ng-container>
      </sub-menu>

      <!-- Rapportage -->
      <menu-item path="reporting/currentBalance" closeOthers="all">
        <tlw-icon icon="graph" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.REPORTING' | translate }}
      </menu-item>

      <!-- More -->
      <menu-group name="more" (click)="toggleMenuState('more')">
        <tlw-icon icon="three-horizontal-dots" library="custom" variant="mini"></tlw-icon>
        <span> {{ 'MAIN.MORE' | translate }} </span>
      </menu-group>
      <sub-menu name="more">
        <!-- Tellow Time -->
        <a (click)="modals.tellowTime.open()">
          {{ 'MAIN.TELLOW_TIME' | translate }}
        </a>
        <!-- My Bookkeeper -->
        <a *showForPlan="['Gratis', 'Basis', 'Plus']" (click)="modals.openBookkeeping()">
          {{ 'MAIN.BOOKKEEP_SUPPORT' | translate }}
        </a>
      </sub-menu>
    </div>

    <!-- Freemium upsell -->
    <ng-container *showForPlan="['Gratis']">
      <div class="menu-bar--upsell">
        <span>
          <tlw-icon icon="crown-dark-green" library="custom" variant="mini" height="12"></tlw-icon>
        </span>
        <p>
          <b>{{ 'COMPONENTS.MENU.UPSELL.TITLE' | translate }}</b>
        </p>
        <p>{{ 'COMPONENTS.MENU.UPSELL.BODY' | translate }}</p>
        <fnc-button purple wide (click)="routeToSettingsForUpselling()">
          {{ 'BUTTONS.UPGRADE' | translate }}
        </fnc-button>
      </div>
    </ng-container>

    <!-- Bottom starts here. -->
    <div class="bottom menu-scope">
      <!-- Support -->
      <a tabindex="0" class="item" (click)="modals.supportModal.open()">
        <tlw-icon icon="buoy" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.SUPPORT' | translate }}
      </a>

      <!-- Instellingen -->
      <menu-item path="settings" closeOthers="settings" [paths]="['settings']" *hideForReadonly>
        <tlw-icon icon="gear" library="heroicons" variant="mini"></tlw-icon>
        {{ 'MAIN.SETTINGS' | translate }}
      </menu-item>
    </div>
  </ul>
</nav>

<!-- Mobile -->
<div class="mobile-overlay hide-above-tablet" (click)="toggleMobileMenu()"></div>
<div class="content" #content>
  <ng-content></ng-content>
</div>

<!-- Modals. Prevent clutter. -->
<modals #modals></modals>

<ng-template #alt>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 356 356" style="height: 2rem; fill: #002e33">
    <path
      d="M90.456847 353.9498c-38.6595-13.81495-66.730127-48.19141-77.84436-95.3314-5.0440603-21.39519-6.4703473-56.74856-2.288893-56.74856 1.38924 0 5.099626 9.70072 8.245378 21.55716 6.88392 25.94452 18.625388 50.34155 29.967016 62.26707 18.838729 19.80835 65.499612 27.56622 92.385072 15.35987 20.94303-9.5085 29.43591-32.10791 20.32889-54.09463-7.03753-16.98988-23.00294-22.67095-52.74161-18.76734 0 0-18.225506-19.61799-24.031923-54.45649l18.680963 1.69391c22.49993 2.04023 39.48794-2.93334 48.30498-14.14211 8.28529-10.53309 8.10614-14.60682-1.11395-25.32571-13.30445-15.46729-37.1933-11.54909-85.561833 14.03365l-24.404945-40.91004 10.231505-7.80398c25.64025-19.556861 70.160433-29.333871 95.496973-20.972031 23.0783 7.61648 40.01713 37.838381 35.49236 63.323811-3.0592 17.22988-16.87495 41.36226-27.54878 48.12041l-9.20507 5.82823 12.71489 5.7336c21.60667 9.74311 34.7971 2.29512 50.5565-28.54673 21.80948-42.68159 35.95449-53.73069 68.84657-53.77798 15.31518-.02204 20.7661 1.58448 31.93654 9.41259 27.87901 19.53706 43.05908 59.99383 39.72492 105.86962-4.2233 58.10163-31.7443 93.34329-72.89389 93.34329-22.58329 0-37.13964-7.92075-48.72686-26.51445-10.17753-16.33229-14.76395-48.67868-8.91924-62.90787 2.80403-6.82637 3.31087-7.05791 3.49418-1.59683.33693 10.04003 11.75936 26.35863 22.24604 31.78149 25.72967 13.30534 62.66652-3.41142 77.28005-34.97515 11.09507-23.9638 5.14273-70.18664-10.08748-78.33768-3.18631-1.70528-11.05995-3.1005-17.49644-3.1005-13.68226 0-24.42731 9.83653-39.49177 36.15272-5.20821 9.09839-13.9732 20.85401-19.47777 26.12354-8.94352 8.56184-12.13717 9.58097-30.02419 9.58097h-20.01655l6.47003 14.37144c9.26095 20.57068 8.82279 53.99335-.97439 74.33978-8.65704 17.97905-28.67358 36.18122-44.67602 40.62666-15.57802 4.32747-40.94585 3.76797-54.876893-1.21033zM165.8338 75.923739c-8.85472-15.10934-14.30406-43.317581-8.36834-43.317581 6.97229 15.126161 21.26491 28.620943 36.56863 38.037101 27.48682 13.30607 55.35848 7.93527 85.80838-16.53502 6.70348-5.38696 12.63984-9.195101 13.19203-8.462541 7.4352 11.538535 20.2965 20.967563 24.54769 34.375751 0 5.65728-24.35352 21.938881-43.57005 29.128621-47.6295 13.72053-80.04616 8.29297-108.17834-33.226331zm24.00223-34.926511l31.00911-34.3834792 34.46079 31.9006692c-11.78717 9.708131-20.29599 24.7747-33.76202 32.415591-10.64019-7.843736-26.52083-17.092193-31.70788-29.932781z"
    ></path>
  </svg>
</ng-template>
